import { Col, Row, Form, Input, Button } from "antd";
import { ImWhatsapp } from "react-icons/im";
import { ImageUrl } from "../../../config/helper";
import { Container } from "postcss";
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const onFinish = (values) => {
  console.log("Success:", values);
};
const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};

const HomeComponent9 = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="laptop:py-16 py-8">
        <Row justify={"center"}>
          <Col lg={18}>
            <Row justify="center" className="items-center">
              <Col xxl={12} md={12} sm={20} xs={20}>
                <h3 className="font-goldman text-white xldesktop:text-[40px] laptop:text-[30px] laptop:leading-[45px] leading-[30px]">
                  Services We Provide,
                </h3>
                <h3 className="font-goldman text-white xldesktop:text-[50px] laptop:text-[34px] xldesktop:leading-[55px] laptop:leading-[40px]">
                  Distance, Half A Day or Full day
                </h3>
              </Col>
              <Col xxl={12} md={12} sm={20} xs={20}>
                <Row>
                  <Col lg={16}>
                    <p className="text-[#666666] text-[15px] antialiased laptop:px-4 md:py-0 py-3">
                      We are based on hourly services and discounted memberships
                      within Manhattan and out of Manhattan. We also provide
                      Distance from Manhattan To out of Manhattan and within
                      Tri-State.
                    </p>
                  </Col>
                  <Col lg={8}>
                    <button
                      className="web-btn py-3 xl:px-12 px-3 text-sm max-xl:text-xs my-4 max-lg:hidden"
                      onClick={() => navigate("/ourModals")}
                    >
                      View All
                    </button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default HomeComponent9;
